import { typographyStyles } from "@newsela/angelou";

const { heading4Obj, fontFamily } = typographyStyles;

export const fieldHeaderCss = {
  margin: "0 0 12px",
  ...heading4Obj,
  ...fontFamily.noto,
};
